export default class {
    _id;
    _organizationId;
    _organization;
    _userId;
    _user;

    get id() {
        return this._id;
    }

    set id(value) {
        this._id = value;
    }

    get OrganizationId() {
        return this._organizationId;
    }

    set OrganizationId(value) {
        this._organizationId = value;
    }

    get Organization() {
        return this._organization;
    }

    set Organization(value) {
        this._organization = value;
    }


    get UserId() {
        return this._userId;
    }

    set UserId(value) {
        this._userId = value;
    }

    get User() {
        return this._user;
    }

    set User(value) {
        this._user = value;
    }
    constructor(id, name, organizationId, organization, user, userId) {
        this._id = id;
        this._organizationId = organizationId;
        this._organization = organization;
        this._userId = userId;
        this._user = user;
    }
}